import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true
});

// Globale Variable für Weiterleitung, da Hooks nur in Komponenten verwendet werden können
let navigateToLogin: (() => void) | null = null;

// Funktion zum Registrieren der Weiterleitungsfunktion
export const registerNavigateToLogin = (callback: () => void) => {
    navigateToLogin = callback;
};

// Funktion zum Anzeigen von Benachrichtigungen
let showSessionExpiredNotification: (() => void) | null = null;

// Funktion zum Registrieren der Benachrichtigungsfunktion
export const registerShowSessionExpiredNotification = (callback: () => void) => {
    showSessionExpiredNotification = callback;
};

// Funktion zum Zurücksetzen des Auth-Status
let resetAuthStatus: (() => Promise<void>) | null = null;

// Funktion zum Registrieren der Auth-Reset-Funktion
export const registerResetAuthStatus = (callback: () => Promise<void>) => {
    resetAuthStatus = callback;
};

// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Bei 401 Unauthorized zur Login-Seite weiterleiten
        if (error.response && error.response.status === 401) {
            console.log('401 Unauthorized: Authentifizierungsstatus zurücksetzen und zur Login-Seite weiterleiten');

            try {
                // Benachrichtigung anzeigen
                if (showSessionExpiredNotification) {
                    showSessionExpiredNotification();
                }

                // Erst Auth-Status zurücksetzen (wenn möglich)
                if (resetAuthStatus) {
                    await resetAuthStatus();
                }

                // Dann zur Login-Seite navigieren
                if (navigateToLogin) {
                    navigateToLogin();
                } else {
                    console.warn('Keine Weiterleitungsfunktion registriert. Manuelles Umleiten zur /login Route.');
                    window.location.href = '/login';
                }
            } catch (e) {
                console.error('Fehler beim Zurücksetzen des Auth-Status:', e);
                // Fallback zur Login-Seite
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;